<template>
  <div>
    <TheVisualWebsiteOptimizer />
    <header class="header-img">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <nav class="navbar navbar-dark navbar-expand-lg">
              <img
                class="csl-logo"
                src="@/assets/images/newLanding/logo_CSL.png"
              >
              <img
                class="epl-logo"
                src="@/assets/images/newLanding/logo_EPL.png"
              >
              <img
                class="nba-logo"
                src="@/assets/images/newLanding/logo_NBA.png"
              >
            </nav>
          </div>
          <div class="col-md-6 navbar-nav d-none d-sm-none d-md-block">
            <div class="nav-item">
              <router-link
                :to="{name: 'login'}"
                tag="a"
                class="btn btn-outline-light my-3"
              >
                登陆
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-5 pt-5 pt-sm-5 pt-md-0">
        <router-link
          :to="{name: 'register'}"
          tag="a"
          class="register2"
        >
          <img
            class="brand"
            src="@/assets/images/logo-white-cn.svg"
            alt=""
          >
          <p class="tagline">
            观看你最爱的体育赛事, <span style="color: #f55637">免费赢取奖励</span><br>
            2018年总奖金超过74,345,500元
          </p>
        </router-link>
        <router-link
          :to="{name: 'register'}"
          tag="a"
          class="btn btn-primary mb-4 mb-sm-4 mb-md-0 register2"
        >
          开始游戏
        </router-link>

        <div class="d-block d-sm-block d-md-none">
          <router-link
            :to="{name: 'login'}"
            tag="a"
            class="btn btn-outline-light"
          >
            登陆
          </router-link>
        </div>
      </div>
    </header>

    <div class="orange" />

    <div class="steps">
      <div class="container">
        <div class="row">
          <div class="col-md-5">
            <div class="img-fluid" />
          </div>

          <div class="col-md-7 d-flex align-items-center">
            <ul class="list-unstyled ui-steps">
              <li class="media my-4">
                <h2>如何游戏</h2>
              </li>
              <li class="media">
                <div class="circle-icon mr-4">
                  1
                </div>
                <div class="media-body">
                  <h5>注册即可游戏</h5>
                  <p>首先创建账户，再成功验证电子邮件之后即可开始游戏和赢利</p>
                </div>
              </li>
              <li class="media my-4">
                <div class="circle-icon mr-4">
                  2
                </div>
                <div class="media-body">
                  <h5>挑选你的球队</h5>
                  <p>选择8位你认为将在下场比赛中得分的球员</p>
                </div>
              </li>
              <li class="media">
                <div class="circle-icon mr-4">
                  3
                </div>
                <div class="media-body">
                  <h5>赢取奖励</h5>
                  <p>坐下来观看比赛，为你最爱的球员加油助威!</p>
                </div>
              </li>
              <li class="media my-4">
                <router-link
                  :to="{name: 'register'}"
                  tag="a"
                  class="btn btn-primary register2"
                >
                  开始游戏
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- // end .section -->

    <div
      id="gallery"
      class="section light-bg"
    >
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <div class="testimonial">
              "接触亚洲最棒的体育应用软件. 这将改变整个游戏产业"<br> - 李成 -
            </div>
          </div>

          <div class="col-md-4">
            <div class="testimonial">
              "丰厚奖励，快捷平台。彻底爱上它"<br> - 张扬 -
            </div>
          </div>

          <div class="col-md-4">
            <div class="testimonial">
              "这个应用软件是由专业体育人士所设计"<br> - 王梅 -
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- // end .section -->

    <footer class="my-4 text-center">
      <!-- Copyright removal is not prohibited! -->
      <p class="mb-2">
        #pick8team
      </p>
      <p>版权所有超级8体育 备案号：辽ICP备19002132号</p>
    </footer>
  </div>
</template>

<script>
import TheVisualWebsiteOptimizer from '@/pages/Home/Components/Molecules/Tracking/TheVisualWebsiteOptimizer'
export default {
  name: 'NewLandingPage',
  components: { TheVisualWebsiteOptimizer },
  metaInfo() {
    return {
      title: this.$t('page-titles.home-public'),
      meta: [
        { name: 'description', content: this.$t('page-descriptions.home-public') },
      ],
    }
  },
}
</script>

<style scoped>
  body {
    font-family: 'Roboto', sans-serif;
    position: relative;
  }

  a {
    color: #f55637;
  }

  a:hover,
  a:focus {
    color: #f55637;
  }

  h1 {
    font-size: 60px;
    font-weight: 300;
    letter-spacing: -1px;
    margin-bottom: 1.5rem;
  }

  h2 {
    font-size: 45px;
    font-weight: 600;
    color: #191c35;
    letter-spacing: -1px;
    margin-bottom: 1rem;
    text-transform: uppercase;
  }

  h3 {
    color: #191c35;
    font-size: 33px;
    font-weight: 500;
  }

  h4 {
    font-size: 20px;
    font-weight: 500;
    color: #191c35;
  }

  h5 {
    font-size: 24px;
    font-weight: 500;
    color: #f55637;
    margin-bottom: 0.7rem;
    text-transform: uppercase;
  }

  p {
    color: #191c35;
  }

  p.lead {
    color: #191c35;
    margin-bottom: 2rem;
  }

  .text-primary {
    color: #191c35 !important;
  }

  .light-font {
    font-weight: 300;
  }

  .btn {
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
    padding: 5px 60px;
    transition: all 0.3s ease;
  }

  .btn-outline-light {
    color: #f8f9fa;
    background-color: transparent;
    background-image: none;
    border: 4px solid #f55637;
    border-radius: 25px;
    float: right;
  }

  .btn-outline-light:hover {
    color: #FFF;
    background-color: #f55637;
    border-color: #f55637;
  }

  @media (max-width:767px) {
    .btn-outline-light {
      float: none;
    }
  }

  .btn-light {
    border-radius: 3px;
    background: #f55637;
    box-shadow: 0px 9px 32px 0px rgba(0, 0, 0, 0.26);
    font-size: 14px;
    font-weight: 500;
    color: #FFF;
    margin: 0.5rem;
    padding: 0.7rem 1.6rem;
    line-height: 1.8;
  }

  .btn-group-lg>.btn,
  .btn-lg {
    padding: 0.8rem 1rem;
    font-size: 15px;
  }

  @keyframes shadow-pulse
  {
    0% {
      box-shadow: 0 0 0 0px rgba(245, 86, 55, 0.3);
    }
    100% {
      box-shadow: 0 0 0 35px rgba(245, 86, 55, 0);
    }
  }

  .btn-primary {
    margin: 50px auto;
    padding: 10px 80px;
    font-size: 18px;
    color: #fff;
    background-color: #f55637;
    border-radius: 25px;
    animation: shadow-pulse 1s infinite;
    border-color: #f55637;
  }
  .btn-primary:hover {
    color: #fff;
    background-color: #d32518;
    border-color: #d32518;
  }
  .btn-primary.focus, .btn-primary:focus {
    box-shadow: 0 0 0 .2rem rgba(0,123,255,.5)
  }
  .btn-primary.disabled, .btn-primary:disabled {
    background-color: #f55637;
  }
  .btn-primary:not([disabled]):not(.disabled).active, .btn-primary:not([disabled]):not(.disabled):active, .show>.btn-primary.dropdown-toggle {
    color: #fff;
    background-color: #f55637;
    box-shadow: 0 0 0 .2rem rgba(0,123,255,.5)
  }

  .btn-steps {
    margin: 50px 0;
    padding: 10px 40px;
    font-size: 18px;
    color: #fff;
    background-color: #f55637;
    border-radius: 25px;
  }
  .btn-steps:hover {
    color: #fff;
    background-color: #d32518;
  }
  .btn-steps.focus, .btn-steps:focus {
    box-shadow: 0 0 0 .2rem rgba(0,123,255,.5)
  }
  .btn-steps.disabled, .btn-steps:disabled {
    background-color: #f55637;
  }
  .btn-steps:not([disabled]):not(.disabled).active, .btn-steps:not([disabled]):not(.disabled):active, .show>.btn-steps.dropdown-toggle {
    color: #fff;
    background-color: #f55637;
    box-shadow: 0 0 0 .2rem rgba(0,123,255,.5)
  }

  .light-bg {
    background-color: #f2efef;
  }

  .steps {
    background-image: url('../../../../assets/images/newLanding/white_bg.png');
    background-repeat: no-repeat;
    background-position: center;
    padding: 20px 0;
  }

  .orange{
    background-color: #e43a26;
    height: 20px;
  }
  .section {
    padding: 30px 0;
  }

  .section-title {
    text-align: center;
    margin-bottom: 3rem;
  }

  .section-title small {
    color: #998a9b;
  }

  @media (max-width:767px) {
    h1 {
      font-size: 40px;
    }
    h2 {
      font-size: 30px;
    }
  }

  /* NAVBAR
  ----------------------*/

  .nav-menu {
    padding: 1rem 0;
    transition: all 0.3s ease;
  }

  .navbar-nav .nav-link {
    position: relative;
  }

  @media (min-width: 992px) {
    .navbar-expand-lg .navbar-nav .nav-link {
      padding-right: 1rem;
      padding-left: 1rem;
      font-size: 14px;
    }
    .navbar-nav>.nav-item>.nav-link.active:after {
      content: "";
      border-bottom: 2px solid #cd99d4;
      left: 1rem;
      right: 1rem;
      bottom: 5px;
      height: 1px;
      position: absolute;
    }
  }

  header {
    padding: 0px 0 0;
    text-align: center;
    color: #FFF;
  }

  .header-img {
    background-image: url('../../../../assets/images/newLanding/slider_products.jpg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    height: 600px;
    width: 100%;
    transition: background-position .8s ease-in-out;
  }
  @media (max-width:767px) {
    .header-img {
      background-image: url('../../../../assets/images/newLanding/slider_products_mobile.jpg');
    }
    span {
      font-weight: bold;
    }
  }

  .tagline {
    font-size: 40px;
    font-weight: 600;
    color: #FFF;
    max-width: 800px;
    margin: 0 auto;
  }

  .img-holder {
    height: 0;
    padding-bottom: 33%;
    overflow: hidden;
  }

  @media (max-width:1200px) {
    .img-holder {
      padding-bottom: 50%;
    }
  }

  @media (max-width:767px) {
    .tagline {
      font-size: 17px;
    }
    .img-holder {
      padding-bottom: 100%;
    }
  }

  .img-fluid {
    max-width: 100%;
    height: auto;
    max-width: 100%;
    height: auto;
    background-image: url('../../../../assets/images/newLanding/iphone.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    width: 455px;
    height: 672px;
  }
  @media (max-width:767px) {
    .img-fluid {
      display: none;
    }
  }

  .box-icon {
    box-shadow: 0px 0px 43px 0px rgba(0, 0, 0, 0.14);
    padding: 10px;
    width: 70px;
    border-radius: 3px;
    margin-bottom: 1.5rem;
    background-color: #FFF;
  }

  .circle-icon {
    box-shadow: 0px 9px 32px 0px rgba(0, 0, 0, 0.07);
    padding: 6px;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    margin-bottom: 6px;
    background-color: #FFF;
    color: #f55637;
    font-size: 48px;
    text-align: center;
    line-height: 80px;
    font-weight: 600;
    transition: all 0.3s ease;
    border: 4px solid #f55637;
  }

  @media (max-width:992px) {
    .circle-icon {
      width: 70px;
      height: 70px;
      font-size: 28px;
      line-height: 50px;
    }
  }

  .ui-steps li:hover .circle-icon {
    background-color: #f55637;
    box-shadow: 0px 9px 32px 0px rgba(0, 0, 0, 0.09);
    color: #FFF;
  }

  .ui-steps li {
    padding: 6px 0;
  }

  .ui-steps li:not(:last-child) {
    border-bottom: 2px solid #f2efef;
  }

  .perspective-phone {
    position: relative;
    z-index: -1;
  }

  @media (min-width:992px) {
    .perspective-phone {
      margin-top: -150px;
    }
  }

  .testimonial {
    background-image: url('../../../../assets/images/newLanding/star.png');
    background-position: top;
    background-repeat: no-repeat;
    padding: 100px 0 20px 0;
    text-align: center;
    font-style: italic;
  }

  /*  FOOTER
  ----------------------*/

  .social-icons {
    text-align: right;
  }

  .social-icons a {
    background-color: #FFF;
    box-shadow: 0px 0px 21px 0px rgba(0, 0, 0, 0.05);
    width: 50px;
    height: 50px;
    display: inline-block;
    text-align: center;
    line-height: 50px;
    margin: 0 0.3rem;
    border-radius: 5px;
    color: #f4c9e2;
    transition: all 0.3s ease;
  }

  .social-icons a:hover {
    text-decoration: none;
    color: #e38cb7;
  }

  @media (max-width:991px) {
    .social-icons {
      text-align: center;
      margin-top: 2rem;
    }
  }

  .csl-logo {
    display: inline-block;
    line-height: inherit;
    white-space: nowrap;
  }
  .epl-logo {
    display: inline-block;
    line-height: inherit;
    white-space: nowrap;
  }
  .nba-logo {
    display: inline-block;
    line-height: inherit;
    white-space: nowrap;
  }
  .brand {
    width: 400px;
  }

  @media (max-width:600px) {
    .brand {
      width: 250px;
    }
  }
  .m-0 {
    margin: 0!important
  }
  .mt-0, .my-0 {
    margin-top: 0!important
  }
  .mr-0, .mx-0 {
    margin-right: 0!important
  }
  .mb-0, .my-0 {
    margin-bottom: 0!important
  }
  .ml-0, .mx-0 {
    margin-left: 0!important
  }
  .m-1 {
    margin: .25rem!important
  }
  .mt-1, .my-1 {
    margin-top: .25rem!important
  }
  .mr-1, .mx-1 {
    margin-right: .25rem!important
  }
  .mb-1, .my-1 {
    margin-bottom: .25rem!important
  }
  .ml-1, .mx-1 {
    margin-left: .25rem!important
  }
  .m-2 {
    margin: .5rem!important
  }
  .mt-2, .my-2 {
    margin-top: .5rem!important
  }
  .mr-2, .mx-2 {
    margin-right: .5rem!important
  }
  .mb-2, .my-2 {
    margin-bottom: .5rem!important
  }
  .ml-2, .mx-2 {
    margin-left: .5rem!important
  }
  .m-3 {
    margin: 1rem!important
  }
  .mt-3, .my-3 {
    margin-top: 1rem!important
  }
  .mr-3, .mx-3 {
    margin-right: 1rem!important
  }
  .mb-3, .my-3 {
    margin-bottom: 1rem!important
  }
  .ml-3, .mx-3 {
    margin-left: 1rem!important
  }
  .m-4 {
    margin: 1.5rem!important
  }
  .mt-4, .my-4 {
    margin-top: 20px!important
  }
  .mr-4, .mx-4 {
    margin-right: 1.5rem!important
  }
  .mb-4, .my-4 {
    margin-bottom: 20px!important
  }
  .ml-4, .mx-4 {
    margin-left: 1.5rem!important
  }
  .m-5 {
    margin: 3rem!important
  }
  .mt-5, .my-5 {
    margin-top: 100px!important
  }
  .mr-5, .mx-5 {
    margin-right: 4rem!important
  }
  .mb-5, .my-5 {
    margin-bottom: 3rem!important
  }
  .ml-5, .mx-5 {
    margin-left: 3rem!important
  }
</style>
